import { Spinner } from '@material-tailwind/react';

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

interface LoadingSpinnerProps {
  /** Size of the spinner */
  size?: SpinnerSize;
  /** Additional CSS classes */
  className?: string;
  /** Screen reader label */
  label?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
};

/**
 * LoadingSpinner component using Material Tailwind Spinner
 * Provides a customizable loading indicator with accessibility support
 */
export function LoadingSpinner({
  size = 'md',
  className = '',
  label = 'Loading...',
}: LoadingSpinnerProps) {
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      role="status"
      aria-label={label}
    >
      <Spinner className={`${sizeMap[size]} text-phish-accent`} />
      <span className="sr-only">{label}</span>
    </div>
  );
}

export default LoadingSpinner;
